
import React, {useEffect, useState} from 'react';


import {connect} from 'react-redux';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyEditorJsReadOnly from '../../components/LoftyEditorJsReadOnly';
import LoftyEditorJs from '../../components/LoftyEditorJs';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';

import {custompreviewarticulosxjyyk_676ae40a9ccea34376cf9960 } from '../../api/contenidoarticulos2dkws.api'

import './blog72ubt.scss';


// Hamburger
function loftyInitHam() {
  try {
  // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}    
    




const Pblog72ubt = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {

	const [loftyres_676ae40a9ccea34376cf9960_component_i997jo, setloftyres_676ae40a9ccea34376cf9960_component_i997jo] = useState([]);

useEffect(() => {
		const loftyHandleData = async () => {
		}
		loftyHandleData();
	}, []);

	useEffect(() => {
		const handleLoftyData = async () => {
			try {
				const responseLoftyApps = await custompreviewarticulosxjyyk_676ae40a9ccea34376cf9960({
				});
				setloftyres_676ae40a9ccea34376cf9960_component_i997jo(responseLoftyApps.data);
			} catch (loftyerror) {
			}
		}
		handleLoftyData();
	}, []);



  
  setTimeout(() => { loftyInitHam(); }, 2000);

  
  

  
  return (
    <div id="id67698b301de4874021c20cd2" >

      <div id="iw4j" className="">
      
      <div id="ips2" className="">
      
      <img
        className=""
        id="iz666f"
        src="https://assetsprojects.s3.amazonaws.com/404ofwim5mu70g5.png"
        alt="undefined"
      />
      
      <div id="itmdc" className="">
      
      <a
        target=""
        className=""
        id="i2aqf"
        href="/"
        type="button"
      >
        
    <div id="i2g1w" className="">
    <>INICIO</>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="iwu1w"
        href="/servicios"
        type="button"
      >
        
    <div id="ib1qi" className="">
    <>SERVICIOS</>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="i31ek"
        href="/blog"
        type="button"
      >
        
    <div id="ipu5h" className="">
    <>ARTICULOS</>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="ig1at"
        href="/contactanos"
        type="button"
      >
        
    <div id="isq53" className="">
    <>CONTÁCTANOS</>
    </div>
    
      </a>
      
      </div>
      
      <div id="ibbry6" className="">
      
      </div>
      
      <div id="iacot" className="">
      
      <span className="material-icons " id="indcti">
        
      <span className="material-icons " id="izk84l">
        
      </span>
      
      </span>
      
        <a
          target="_blank"
          className=""
          id="isdo4d"
          href=""
        >
          
      <span className="material-icons " id="i3c93a">
        <>call</>
      </span>
      
        </a>
        
        <a
          target="_blank"
          className=""
          id="igbhjj"
          href=""
        >
          
      <span className="material-icons " id="iu387l">
        <>mail</>
      </span>
      
        </a>
        
      </div>
      
      <div id="icq3pj" className="">
      
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <label id="" className="menu__close__btn ">
      
      <span className="span__close__left " id="">
        
      </span>
      
      <span className="span__close__right " id="">
        
      </span>
      
      </label>
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/"
        type=""
      >
        <>INICIO</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/servicios"
        type=""
      >
        <>SERVICIOS</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/articulos"
        type=""
      >
        <>ARTICULOS</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/contactanos"
        type=""
      >
        <>CONTÁCTANOS</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      </li>
      
      </ul>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ihk8" className="">
      
      <div
        id="i9joyb"
        className=""
        data-aos="fade-up"
        data-aos-duration="2000"
      >
      
      <div id="it6xg" className="">
      
      <div className="" id="ip3sl">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i9ij45">
        <>Blog</>
      </span>
      
      </div>
      
      <div id="iwm6zf" className="">
      
      </div>
      
      <div className="" id="i803s">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ifdapi">
        <>Compartiremos casos de estudio e historias inspiradoras de personas y organizaciones que han dado el salto hacia un futuro energéticamente sostenible.</>
      </span>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i6xx" className="">
      
      <div id="i0tfl" className="">
      
      <div id="i5a0dm" className="">
      
      <div className="" id="i1tmsr">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ih806l">
        <>Bienvenidos a Nuestro Blog de Wellness</>
      </span>
      
      </div>
      
      <div className="" id="ies552">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="il2hgx">
        <>Id nisl lacus penatibus bibendum vitae lectus et a. Lorem nulla nulla nulla faucibus amet feugiat ultricies. Posuere arcu enim.</>
      </span>
      
      </div>
      
        <a
          target=""
          className=""
          id="i1amgn"
          href="#"
        >
          
    <div id="ia2fz7" className="">
    <>IR AL BLOG</>
    </div>
    
        </a>
        
      </div>
      
      <div id="i1xrzo" className="">
      
      <img
        className=""
        id="il24tg"
        src="https://assetsprojects.s3.amazonaws.com/404no3im518lg7w.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      <div id="iwdze7" className="">
      
      <div
        id="ijzi3m"
        className=""
        data-aos="zoom-out-up"
        data-aos-duration="2000"
      >
      
      <div id="ia2meh" className="">
      
      <div className="" id="iiew7j">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i1nsox">
        <>Talvez también te interese</>
      </span>
      
      </div>
      
        <div id="i997jo" className="">
        
            {
              loftyres_676ae40a9ccea34376cf9960_component_i997jo.map((loftyitem_676ae40a9ccea34376cf9960_component_i997jo) => (
                <div key={loftyitem_676ae40a9ccea34376cf9960_component_i997jo._id} className="" id="ia01yz">
                  
        <div className="" id="i501qk">
          
          <div className="" id="">
            {loftyitem_676ae40a9ccea34376cf9960_component_i997jo?.titulounthz}
          </div>
          
        </div>
        
        <div className="" id="ikxsgp">
          
          <div className="" id="">
            {loftyitem_676ae40a9ccea34376cf9960_component_i997jo?.resumenstke}
          </div>
          
        </div>
        
        <a
          target=""
          className=""
          id="iom3li"
          href="#"
        >
          
    <div id="" className="">
    <>IR AL BLOG</>
    </div>
    
        </a>
        
                </div>
              ))
            }
            
        </div>
        
      </div>
      
      </div>
      
      </div>
      
      <div id="ie001w" className="">
      
      <div className="" id="iaf1yl">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ic8cuf">
        <>Tema destacado</>
      </span>
      
      </div>
      
      <div
        id="ipeu47"
        className=""
        data-aos="zoom-in-up"
        data-aos-duration="2000"
      >
      
        <div id="i0pv69" className="">
        
        </div>
        
      </div>
      
      </div>
      
      </div>
      
      <div id="icohi" className="">
      
      <div id="iyghfd" className="">
      
      <div id="i52pnr" className="">
      
      <div className="" id="iyo7r6">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i9f89n">
        <>Choloma, Cortes</>
      <br className="" id="" />
      <>Res. Bello Horizonte, Segunda etapa</>
      </span>
      
      </div>
      
      <div id="i3kbn4" className="">
      
        <a
          target="_blank"
          className=""
          id="ixsthl"
          href="#"
        >
          
      <img
        className=""
        id="iwpiyw"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4x6jbbv.png"
        alt="undefined"
      />
      
        </a>
        
        <a
          target="_blank"
          className=""
          id="ikcig4"
          href="#"
        >
          
      <img
        className=""
        id="iv6mle"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4x6jd5s.png"
        alt="undefined"
      />
      
        </a>
        
        <a
          target="_blank"
          className=""
          id="itq03p"
          href="#"
        >
          
      <img
        className=""
        id="isa627"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4x6jfas.png"
        alt="undefined"
      />
      
        </a>
        
        <a
          target="_blank"
          className=""
          id="ig3kxb"
          href="#"
        >
          
      <img
        className=""
        id="iqlafz"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4x6jgsb.png"
        alt="undefined"
      />
      
        </a>
        
      </div>
      
      </div>
      
      <img
        className=""
        id="iqk4h7"
        src="https://assetsprojects.s3.amazonaws.com/404ofwim5mu722a.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="iou1pv" className="">
      
      <div id="i2vw8i" className="">
      
      </div>
      
      <div id="iabdji" className="">
      
      <div id="izci0t" className="">
      
      <div className="" id="izq2dp">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="iubk6b">
        <>Copyrigt © 2024 </>
      </span>
      
      </div>
      
      <div className="" id="i4zwph">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="ix41ho">
        <>Terapias Energéticas</>
      </span>
      
      </div>
      
      </div>
      
      <div id="ip8opa" className="">
      
      <div className="" id="in8zl9">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="iytx9d">
        <>Términos y condiciones</>
      </span>
      
      </div>
      
      <div className="" id="ivyeul">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i5zx35">
        <>Políticas de privacidad</>
      </span>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pblog72ubt);
  